<template>
  <div class="version-manager">
    <div class="version-manager__sprite">
      <versionsIcon />
    </div>

    <div class="version-manager__save-info" role="status">
      <div v-if="versions.isSaving && !saveError" class="version-manager__save-in-progress">
        <svg width="51" height="51" class="version-manager__save-progress-icon">
          <use xlink:href="#save-in-progress-icon"></use>
        </svg>
        Saving
      </div>

      <div v-else-if="versions.isSaved" class="version-manager__save-complete">
        <svg width="10" height="10" class="version-manager__save-complete-icon">
          <use xlink:href="#saved-tick"></use>
        </svg>
        Saved
      </div>

      <div class="version-manager__last-saved" v-if="versions.lastSave">
        Saved at {{ versions.lastSave }}
      </div>

      <div v-if="saveError" class="version-manager__save-failed">
        Auto-save failed <button @click="$emit('save')">try again</button>
      </div>
    </div>

    <button
      @click="undo"
      class="version-manager__move-version-button"
      :disabled="versions.past.length <= 1"
    >
      <svg width="50" height="22">
        <use xlink:href="#undo-arrow"></use>
      </svg>
      Undo
    </button>

    <button
      @click="redo"
      class="version-manager__move-version-button"
      :disabled="!versions.future.length"
    >
      <svg width="50" height="22">
        <use xlink:href="#redo-arrow"></use>
      </svg>
      Redo
    </button>
  </div>
</template>

<script>
import versionsIcon from '../../assets/versions-icons.svg';

export default {
  name: 'VersionManager',
  components: {
    versionsIcon,
  },
  props: {
    versions: {
      default: () => {},
      type: Object,
    },
    saveError: {
      default: () => '',
      type: String,
    },
  },
  methods: {
    undo() {
      if (this.versions.past.length > 1) {
        this.$emit('undo', this.versions.back());
      }
    },
    redo() {
      if (this.versions.future.length) {
        this.$emit('redo', this.versions.forward());
      }
    },
  },
};
</script>

<style>
.version-manager {
  display: flex;
  align-items: bottom;
}

.version-manager__sprite {
  display: none;
}

.version-manager__move-version-button {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 6ch;
  cursor: pointer;
  align-items: center;
  line-height: 1;
  border: none;
  background: none;
}

.version-manager__move-version-button svg {
  width: 3ch;
}

.version-manager__move-version-button[disabled] {
  opacity: 0.3;
}

.version-manager__save-info {
  text-align: right;
  margin-right: 1ch;
  display: flex;
  flex-direction: column-reverse;
}

.version-manager__last-saved {
  font-size: 0.8rem;
}

.version-manager__save-in-progress {
  font-size: 0.8rem;
  line-height: 1;
}

.version-manager__save-progress-icon {
  width: 1.5ch;
  height: auto;
  animation: rotation 2s linear infinite;
}

.version-manager__save-complete {
  font-size: 0.8rem;
  line-height: 1;
}

#saved-tick-path {
  stroke: rgb(45, 209, 45);
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}
</style>
